// extracted by mini-css-extract-plugin
module.exports = {"container":"circle_container__2PDgM","pageFlagBox":"circle_pageFlagBox__24V31"};